import { useEffect } from "react";
import { appStore } from "src/framework/store/AppStore";
import { ProjetoVertical } from 'src/components/projetos/verticais'

const PAGE_TITLE = "Projeto especial";

const ProjetoVerticalPage = () => {

  useEffect(() => {
    appStore.setPageTitle(PAGE_TITLE);
    return () => {
      appStore.setPageTitle("");
    }
  }, [])

  return (
    <div className="container">
      <div className="row">
        <div className="X12">
          <ProjetoVertical />
        </div>
      </div>
    </div>
  );
};

export { ProjetoVerticalPage };
